<a class="notification-link" (click)="downloadFile()">{{
    'Dashboard::ClickHereToDownloadAgentPerformanceReport' | abpLocalization
  }}</a>